module.exports = __webpack_public_path__ + "static/media/screen3.9005a289.png";